export const formatMXN = (amount) => {
  if (amount === null || amount === undefined) return "$0.00";
  return new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2,
  }).format(amount);
};

export const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  return new Date(dateStr).toLocaleDateString("es-MX", {
    year: "numeric", month: "short", day: "numeric",
  });
};

export const formatDateTime = (dateStr) => {
  if (!dateStr) return "-";
  return new Date(dateStr).toLocaleString("es-MX", {
    year: "numeric", month: "short", day: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
};

export const typeLabels = {
  cotizacion: "Cotización",
  pedido: "Pedido",
  factura: "Factura",
  ticket: "Ticket",
  importada: "Importada",
};

export const statusLabels = {
  borrador: "Borrador",
  pendiente: "Pendiente",
  confirmado: "Confirmado",
  listo_para_surtir: "Listo para Surtir",
  pagado: "Pagado",
  enviado: "Enviado",
  entregado: "Entregado",
  cancelado: "Cancelado",
  en_proceso: "En Proceso",
  completado: "Completado",
  completada: "Completada",
  recibida: "Recibida",
};

export const statusColors = {
  borrador: "bg-slate-100 text-slate-600",
  pendiente: "bg-yellow-100 text-yellow-700",
  confirmado: "bg-blue-100 text-blue-700",
  listo_para_surtir: "bg-emerald-100 text-emerald-700",
  pagado: "bg-brand-100 text-brand-700",
  enviado: "bg-amber-100 text-amber-700",
  entregado: "bg-emerald-100 text-emerald-700",
  cancelado: "bg-red-100 text-red-700",
  en_proceso: "bg-amber-100 text-amber-700",
  completado: "bg-brand-100 text-brand-700",
  recibida: "bg-blue-100 text-blue-700",
};

export const categoryLabels = {
  producto_final: "Producto Terminado",
  materia_prima: "Materia Prima",
  insumo_directo: "Insumo Directo",
  insumo_indirecto: "Insumo Indirecto",
  material_empaque: "Material de Empaque",
};

export const roleLabels = {
  admin: "Administrador",
  vendedor: "Vendedor",
  auxiliar: "Auxiliar",
};
